module.exports = __webpack_public_path__ + "img/Alyssa.fb711ce5.jpg";